module.exports = __webpack_public_path__ + "static/img/friend2.4275a60.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/friend2.jpeg
// module id = aFgw
// module chunks = 1